<template>
  <div class="login-bg">
    <div class="login-mask">
      <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form"
        @submit.native.prevent="handleLogin">
        <div class="login-title">老关中驾校管理系统</div>
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="账号" prefix-icon="el-icon-user" clearable size="large"
            class="login-input" @keyup.enter.native="handleLogin" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input placeholder="请输入密码" v-model="loginForm.password" :type="showPwd ? 'text' : 'password'" clearable
            size="large" class="login-input" prefix-icon="el-icon-s-operation" @keyup.enter.native="handleLogin"
            show-password />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="login-btn" size="large" @click="handleLogin" :loading="loading" round
            block>登录</el-button>
        </el-form-item>
        <!-- <el-alert v-if="error" :title="error" type="error" show-icon class="login-error" /> -->
      </el-form>
    </div>
    <div class="sign">
      <a href="https://beian.miit.gov.cn/" target="_blank">陕ICP备2025073418号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      showPwd: false,
      loading: false,
      error: '',
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 3, message: '密码长度不能少于3位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    togglePwd() {
      this.showPwd = !this.showPwd
    },
    async handleLogin() {
      this.error = ''
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        try {
          const { username, password } = this.loginForm
          const response = await this.$http.post('/api/accounts/validate', {
            username,
            password
          })
          if (response.data.success === true) {
            // 登录成功
            this.$message.success(response.data.message || '登录成功')
            this.$store.commit('login')
            this.$store.commit('setRole', response.data.data.description)
            this.$router.push('/')
          } else {
            this.$message.error(response.data.message || '登录失败')
          }
        } catch (error) {
          const errorMessage = error.response?.data?.message || '登录失败'
          this.error = errorMessage
          console.error('Login Error:', error)
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-bg {
  width: 100vw;
  height: 100vh;
  background: url('~@/assets/bg.png') center center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.sign {
  position: absolute;
  bottom: 40px;
  right: 40px;
}

.login-mask {
  background: rgba(255, 255, 255, 0.85);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  padding: 48px 36px 32px 36px;
  min-width: 340px;
  max-width: 90vw;
  min-height: 380px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-title {
  font-size: 26px;
  font-weight: bold;
  color: #409EFF;
  text-align: center;
  margin-bottom: 32px;
  letter-spacing: 2px;
}

.login-input>>>.el-input__inner {
  border-radius: 24px;
  height: 44px;
  font-size: 16px;
}

.pwd-eye {
  cursor: pointer;
  font-size: 20px;
  color: #bfbfbf;
  transition: color 0.2s;
  margin-right: 6px;
}

.pwd-eye:hover {
  color: #409EFF;
}

.login-btn {
  width: 100%;
  border-radius: 24px;
  background: linear-gradient(90deg, #409EFF 0%, #66b1ff 100%);
  border: none;
  font-size: 18px;
  height: 44px;
  margin-top: 8px;
}

.login-btn:focus {
  outline: none;
}

.login-error {
  margin-top: 15px;
  border-radius: 6px;
}

.login-error ::v-deep .el-alert__content {
  text-align: center;
}

.login-error ::v-deep .el-alert__title {
  font-size: 14px;
  font-weight: 500;
}

@media (max-width: 500px) {
  .login-mask {
    padding: 24px 8px 16px 8px;
    min-width: 90vw;
  }

  .login-title {
    font-size: 20px;
  }
}
</style>